var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".performance_svg__st3{fill:#ed4300}");

var _ref3 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "performance_svg__SVGID_1_",
  d: "M0 0h80v80H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "performance_svg__SVGID_00000141417775543765324190000014071812468421069955_"
}, /*#__PURE__*/React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#performance_svg__SVGID_1_"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#eaeaea",
  d: "M40.001 80c22.093 0 40-17.909 40-40 0-22.093-17.907-40.001-40-40.001S.001 17.908.001 40s17.907 40 40 40"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#260046",
  d: "M58.562 60.415H21.438a1.985 1.985 0 01-1.986-1.986V23.337a1.986 1.986 0 013.972 0v33.105h35.138a1.986 1.986 0 110 3.973"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.033 41.748h6.37v10.609h-6.37z",
  className: "performance_svg__st3"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.748 29.736h6.367v22.621h-6.367z",
  className: "performance_svg__st3"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.464 32.98h6.367v19.377h-6.367z",
  className: "performance_svg__st3"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#performance_svg__SVGID_00000141417775543765324190000014071812468421069955_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.179 22.582h6.367v29.775h-6.367z",
  className: "performance_svg__st3"
}))));

var SvgPerformance = function SvgPerformance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "performance_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerformance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/performance.d1c9a175.svg";
export { ForwardRef as ReactComponent };